var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.82,
    height: 20,
    viewBox: "0 0 26.82 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_check",
    "data-name": "solid check",
    d: "M9.11,84.705.393,75.989a1.341,1.341,0,0,1,0-1.9l1.9-1.9a1.341,1.341,0,0,1,1.9,0l5.872,5.872L22.635,65.491a1.341,1.341,0,0,1,1.9,0l1.9,1.9a1.341,1.341,0,0,1,0,1.9L11.006,84.706A1.341,1.341,0,0,1,9.11,84.705Z",
    transform: "translate(0 -65.098)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders-icon.ea94dfb6443352e41d12d33c1c8c3cd4.svg";
export { ForwardRef as ReactComponent };